import { render, staticRenderFns } from "./AiAssistantCustomersComponent.vue?vue&type=template&id=2fd74709&scoped=true"
import script from "./AiAssistantCustomersComponent.vue?vue&type=script&lang=js"
export * from "./AiAssistantCustomersComponent.vue?vue&type=script&lang=js"
import style0 from "./AiAssistantCustomersComponent.vue?vue&type=style&index=0&id=2fd74709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd74709",
  null
  
)

export default component.exports